import {
  HttpPromiseWithEntireResponse,
  ApiError,
  sendApiErrorToSentry,
} from "@shared/svelte/Modules/ApiService";

const $http = async function (params) {
  const originalParams = { ...params };

  if (params.method == "GET") {
    params.data = params.params;
  }
  const res = await HttpPromiseWithEntireResponse(params);
  const contentType: string[] = res.headers.get("Content-Type")?.split(";") || [];
  const hasJson: boolean = contentType.includes("application/json");
  let json;

  if (res.ok) {
    if (hasJson) {
      json = await res.json();
    }
    return Promise.resolve({ data: json });
  } else {
    if (hasJson) return Promise.reject({ data: await res.json() });

    const error = new ApiError(`${res.status} ${originalParams.method} - ${originalParams.url}`);
    error.status = res.status;

    sendApiErrorToSentry({
      error,
      status: res.status,
      params: originalParams,
    });

    return Promise.reject(error);
  }
};
window["$http"] = $http;
export default $http;
